import { useDebounceCallback } from '@react-hook/debounce';
import { useContext, useEffect, useState } from 'react';

const useFilteredListData = ({ Context, listFilters }) => {
  const {
    state: { filterSets }
  } = useContext(Context);
  const [filteredList, setFilteredList] = useState(Object.values(filterSets));

  const filterList = () => {
    const filterByType = filterSet => filterSet.type === listFilters.type;

    const filterBySearchValue = filterSet =>
      filterSet.name
        ?.toLowerCase()
        .includes(listFilters.searchValue?.toLowerCase()) ||
      filterSet.owner_name
        ?.toLowerCase()
        .includes(listFilters.searchValue?.toLowerCase());

    const filteredList = Object.values(filterSets)
      .filter(filterByType)
      .filter(filterBySearchValue);

    setFilteredList(filteredList);
  };

  const debouncedFilterList = useDebounceCallback(filterList, 400);

  useEffect(() => {
    filterList();
  }, [filterSets, listFilters?.type]);

  useEffect(() => {
    debouncedFilterList();
  }, [listFilters?.searchValue]);

  return filteredList;
};

export default useFilteredListData;
